import { cloneDeep } from 'lodash-es'
import * as Yup from 'yup'
import { Rule } from './types'

export enum RULE_FORM_FIELDS {
  ID = 'id',
  NAME = 'ruleName',
  FIELDPATH = 'fieldPath',
  SALESFORCEFIELDPATH = 'salesforceFieldPath',
  DATA_TYPE = 'dataType'
}

export interface IRuleForm {
  [RULE_FORM_FIELDS.ID]: string;
  [RULE_FORM_FIELDS.NAME]: string;
  [RULE_FORM_FIELDS.FIELDPATH]: string;
  [RULE_FORM_FIELDS.SALESFORCEFIELDPATH]: string;
  [RULE_FORM_FIELDS.DATA_TYPE]: string;
}

export const RuleFormLabels: Record<string, string> = {
  [RULE_FORM_FIELDS.ID]: 'Rule ID',
  [RULE_FORM_FIELDS.NAME]: 'Rule Name',
  [RULE_FORM_FIELDS.FIELDPATH]: 'Field Path',
  [RULE_FORM_FIELDS.SALESFORCEFIELDPATH]: 'Default Value',
  [RULE_FORM_FIELDS.DATA_TYPE]: 'Data Type'
}

export const defaultRuleFormValues: IRuleForm = {
  [RULE_FORM_FIELDS.NAME]: '',
  [RULE_FORM_FIELDS.ID]: '',
  [RULE_FORM_FIELDS.FIELDPATH]: '',
  [RULE_FORM_FIELDS.SALESFORCEFIELDPATH]: '',
  [RULE_FORM_FIELDS.DATA_TYPE]: ''
}

export const getInitialRuleFormValueFromResponse = (
  response: Rule
): IRuleForm => {
  const {
    id = '',
    ruleName = '',
    fieldPath = '',
    salesforceFieldPath = '',
    dataType = ''
  } = response

  const formInitialValues: IRuleForm = {
    [RULE_FORM_FIELDS.NAME]: ruleName,
    [RULE_FORM_FIELDS.ID]: id,
    [RULE_FORM_FIELDS.FIELDPATH]: fieldPath,
    [RULE_FORM_FIELDS.SALESFORCEFIELDPATH]: salesforceFieldPath,
    [RULE_FORM_FIELDS.DATA_TYPE]: dataType
  }

  return cloneDeep(formInitialValues)
}

export const ruleValidationSchema = Yup.object().shape({
  [RULE_FORM_FIELDS.NAME]: Yup.string().required('Rule Name is required'),
  [RULE_FORM_FIELDS.FIELDPATH]: Yup.string().required('Field Path is required'),
  [RULE_FORM_FIELDS.SALESFORCEFIELDPATH]: Yup.string().required(
    'Default Value is required'
  ),
  [RULE_FORM_FIELDS.DATA_TYPE]: Yup.string().required('Data Type is required')
})
